import styled from "@emotion/styled";
import StarIcon from "@mui/icons-material/Star";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Typography } from "@mui/material";
import { shouldForwardProp } from "../../common/Common.style";
import theme from "../../theme";
import { HHNTheme } from "hhn-commons";

export const MessageContentTypeWrapper = styled(Box)`
  padding: 0;
`;

export const MessageTitle = styled(Box)`
  padding: 5px 6px 0;
`;

type MessageContentWrapperProps = {
  disableActions?: boolean;
};

export const MessageContentWrapper = styled(Box, {
  shouldForwardProp: prop =>
    shouldForwardProp<MessageContentWrapperProps>(["disableActions"], prop),
})<MessageContentWrapperProps>(({ disableActions }) => ({
  padding: "5px 6px 6px",
  pointerEvents: disableActions ? "none" : "auto",
}));

export const MessageFooterStyle = styled(Box)`
  margin: 0 10px 4px;
  align-items: center;
  gap: 5px;
`;

export const MessageFooterFirstRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 8px;
  row-gap: 2px;
  position: relative;

  & [data-testid="message-send-failed"],
  & [data-testid="message-pending-status"] {
    position: static;
  }
`;

export const MessageFooterSecondRow = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
`;

export const MessageTimeComponent = styled(Typography)`
  text-align: right;
  color: grey;
  display: block;
  white-space: nowrap;
  margin-left: auto;
`;

export const StarredMessageIcon = styled(StarIcon)`
  font-size: 17px;
`;

export const MessageVisibilityIcon = styled(VisibilityIcon)`
  font-size: 17px;
`;

/* Option A: the state reads neutral and only the action carries colour, so a
   screen full of failures informs rather than alarms. */
export const MessageSendFailedLabel = styled("span")`
  font-size: 13px;
  color: ${HHNTheme.onSurfaceVariant};
  white-space: nowrap;
`;

export const MessageStatusSeparator = styled("span")`
  font-size: 13px;
  color: ${HHNTheme.outlineVariant};
`;

export const MessageRetryButton = styled("button")`
  appearance: none;
  border: none;
  background: none;
  /* Padding, not margin: it grows the hit area rather than the dead space
     around it. */
  padding: 2px 4px;
  margin: -2px -4px;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  color: ${theme.palette.error.main};

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${theme.palette.error.main};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const MessageVisibilityStatusComponent = styled(Typography)`
  text-align: right;
  color: grey;
  display: block;
`;
